import { useState, useCallback } from 'react';

/**
 * Socrates API 호출을 위한 Hook
 * 로딩 상태, 에러 처리 등을 관리
 */
export const useSocratesApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * API 호출 실행 및 상태 관리
   * @param {Function} apiCall - 실행할 API 함수
   * @returns {Promise<any>} API 응답 결과
   */
  const executeApi = useCallback(async (apiCall) => {
    setLoading(true);
    setError(null);

    try {
      const result = await apiCall();
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * 에러 초기화
   */
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    loading,
    error,
    executeApi,
    clearError
  };
};
